
import Main from "./components/main/Main";
import SideNav from "./components/sidenav/SideNav";
import Login from "./Login";
import "./Home.css"


function App() {
  return (
    <div className="App">
        
      <div className="container">
   
         <SideNav/>
         <Main/>
         
      </div>
    </div>
  );
}

export default App;